// @ts-nocheck

class ProductShareCopy {
  constructor() {
    this.btns = document.querySelectorAll('[data-share-copy]');
    if (!this.btns.length) return;
    this.timer = null;
    this.btns.forEach((btn) => {
      btn.addEventListener('click', () => this.copy(btn));
    });
  }

  copy(btn) {
    const url = btn.dataset.copyUrl;
    if (!url) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(() => this.showFeedback(btn)).catch(() => this.fallbackCopy(url, btn));
    } else {
      this.fallbackCopy(url, btn);
    }
  }

  fallbackCopy(url, btn) {
    const input = document.createElement('textarea');
    input.value = url;
    input.setAttribute('readonly', '');
    input.style.position = 'absolute';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    this.showFeedback(btn);
  }

  showFeedback(btn) {
    const tip = btn.querySelector('[data-share-feedback]');
    if (!tip) return;
    tip.hidden = false;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      tip.hidden = true;
    }, 2000);
  }
}

new ProductShareCopy();
